module.exports = __webpack_public_path__ + "static/wordpress-c19c11beaafb67d710b0d046777b4966.svg";